import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AbstractAppStatsSearch } from '../../../models/appstats/appstats-search.model';
import { WebhookConnectorInboundEventResult } from '../../../models/appstats/universal-webhook-connector/webhook-connector-inbound-event-result.model';
import { ErrorHandlingService } from '../../error-handling/error-handling.service';
import { HttpHeaderConstants } from '../../http-header.constant';
import { SpinnerService } from '../../spinner';
import { catchError, finalize, Observable, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UniversalWebhookConnectorInboundEventResultService {
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #http = inject(HttpClient);
    readonly #spinnerService = inject(SpinnerService);

    private APPSTATS_RESULT_URL = environment.publicApiHost + '/appcloud/webhook-connector-inbound-event-results';

    search(search: WebhookConnectorInboundEventResultSearch): Observable<WebhookConnectorInboundEventResult[]> {
        const process = 'UniversalWebhookConnectorInboundEventResultService.search';
        this.#spinnerService.addProcess(process, 'Retrieving your event results...');

        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams(),
        };

        for (const [key, value] of Object.entries(search)) {
            httpOptions.params = httpOptions.params.set(key, value as string | number | boolean);
        }

        return this.#http.get<WebhookConnectorInboundEventResult[]>(this.APPSTATS_RESULT_URL, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(error, false, 'An error occurred. Please try again later.');
                return of<WebhookConnectorInboundEventResult[]>();
            }),
            finalize(() => this.#spinnerService.completeProcess(process))
        );
    }
}

export interface WebhookConnectorInboundEventResultSearch extends AbstractAppStatsSearch {
    appinstanceId?: number;
    inboundEventRecordIds?: number[];
}
